import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { isEmpty } from '../../helpers/isEmpty';
import { withRouter } from 'react-router-dom';
import ChannelListItem from './ChannelListItem';
import Grid from '@material-ui/core/Grid';
import SimpleCollection from '../Organisms/SimpleCollection/';
import SimpleDialog from '../../Components/Atoms/SimpleDialog/';
import Typography from '@material-ui/core/Typography';
export interface ISortEndProps {
    oldIndex: number;
    newIndex: number;
}
export interface IChannelsListProps extends RouteComponentProps {
    syncChannels: any;
    event_name: string;
    setChannelActive: Function;
    setChannelEditing: Function;
    removeChannel: Function;
    syncChannelMessages: any;
    reorderChannels: any;
    active_channel_id: string;
    channels: any[];
}

const ChannelsList = (props: IChannelsListProps) => {
    const {
        active_channel_id,
        channels,
        history,
        removeChannel,
        reorderChannels,
        setChannelActive,
        setChannelEditing,
        syncChannelMessages,
        syncChannels,
    } = props;
    const [confirmationDialog, setConfirmationDialog] = React.useState(false);
    const [channelIdForRemoval, setChannelIdForRemoval] = React.useState('');
    React.useEffect(() => {
        // syncChannels()
    }, [syncChannels]); //If user is logged in this will succeed

    const triggerRemove = (channel_id: string) => {
        setConfirmationDialog(true);
        setChannelIdForRemoval(channel_id);
    };
    const handleRemove = (channel_id: string) => {
        setConfirmationDialog(false);
        if (!isEmpty(channelIdForRemoval)) removeChannel(channelIdForRemoval);
        setChannelIdForRemoval('');
    };
    const handleCancelConfirmation = () => {
        setConfirmationDialog(false);
        setChannelIdForRemoval('');
    };
    const handleEditMode = (channel_id: string) => {
        setChannelEditing(channel_id);
        history.push('channels/modify');
    };
    const handleCreate = () => {
        history.push('channels/new');
    };

    return (
        <React.Fragment>
            <SimpleDialog
                onCancel={handleCancelConfirmation}
                onOk={handleRemove}
                open={confirmationDialog}
                title="Remove Channel"
            >
                <Typography component="p" variant="body1">
                    Are you sure you want to remove the channel?
                </Typography>
            </SimpleDialog>
            <Grid data-cy="Channels-list" item md={5} xs={12}>
                <Typography component="h2" gutterBottom={true} variant="h5">
                    Active Channels
                </Typography>
                <SimpleCollection
                    data={channels}
                    fabPosition="absolute"
                    fabRight={'0'}
                    height="50vh"
                    itemRender={(channel, idx) => {
                        return (
                            <ChannelListItem
                                disabled={true}
                                enabledEditMode={handleEditMode}
                                id={channel.id}
                                image={channel.imageURL}
                                name={channel.name}
                                remove={triggerRemove}
                                selected={channel.id === active_channel_id}
                                setChannelActive={setChannelActive}
                                syncChannelMessages={syncChannelMessages}
                            />
                        );
                    }}
                    mode="dark"
                    onCreate={handleCreate}
                    onSort={reorderChannels}
                    reorderable={true}
                    type="list"
                />
            </Grid>
        </React.Fragment>
    );
};

export default withRouter(ChannelsList);
